import { useEffect, useRef } from 'react'
import * as THREE from 'three'
import type { AvatarPresentation } from '../types'

type UseAvatarPresentationTargetsParams = {
  avatarPresentation?: AvatarPresentation
}

export const useAvatarPresentationTargets = ({ avatarPresentation }: UseAvatarPresentationTargetsParams) => {
  const targetPositionRef = useRef(new THREE.Vector3())
  const targetEulerRef = useRef(new THREE.Euler())
  const targetQuaternionRef = useRef(new THREE.Quaternion())

  useEffect(() => {
    if (!avatarPresentation) return

    /** オイラー角からクォータニオンへ変換し、回転ターゲットを初期化する */
    const rotation = avatarPresentation.transform.rotation
    targetEulerRef.current.set(rotation?.x ?? 0, rotation?.y ?? 0, rotation?.z ?? 0)
    targetQuaternionRef.current.setFromEuler(targetEulerRef.current)
  }, [avatarPresentation])

  const syncPositionTarget = (presentation: AvatarPresentation | undefined) => {
    if (!presentation) return

    /** フレームごとに解決済み presentation から位置ターゲットを更新する */
    const offset = presentation.placement.offset
    targetPositionRef.current.set(offset?.x ?? 0, offset?.y ?? 0, offset?.z ?? 0)
  }

  const getNextScale = ({
    currentScale,
    presentation,
    lerpAlpha,
  }: {
    currentScale: number
    presentation: AvatarPresentation | undefined
    lerpAlpha: number
  }): number => {
    /** 拡大縮小は毎フレームなめらかに追従させる */
    const scale = presentation?.transform.scale ?? 1
    return THREE.MathUtils.lerp(currentScale, scale, lerpAlpha)
  }

  return {
    targetPositionRef,
    targetQuaternionRef,
    syncPositionTarget,
    getNextScale,
  }
}
